import { render } from "./ReportsBetting.vue?vue&type=template&id=275378d4"
import script from "./ReportsBetting.vue?vue&type=script&lang=js"
export * from "./ReportsBetting.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__